module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"AAA Carolinas","short_name":"AAA Carolinas","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/aaa-orbit-alone.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"fb74b3002e388933d398da3ff2046406"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
